<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { AddProjectsDialogViewModel } from "@Quest/PortfolioScenarios/Components/AddProjectsDialog";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class AddProjectsDialog extends Vue
    {
        get vm(): AddProjectsDialogViewModel { return this.$props.viewModel as AddProjectsDialogViewModel; }
        get opened() : boolean { return this.vm?.opened ?? false; }

        get statuses() { return this.vm.statuses; }
        get lists() { return this.vm.lists; }
        
        get selectedListId() : string | null { return this.vm.selectedListId; }
        set selectedListId(val: string | null) { this.vm.selectedListId = val; }

        get selectedStatusId() : number | null { return this.vm.selectedStatusId; }
        set selectedStatusId(val: number | null) { this.vm.selectedStatusId = val; }

        handleConfirm()
        {
            this.$emit('selection-confirmed', this.vm.selectedListId, this.vm.selectedStatusId);
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add projects to scenario</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group">
                            <label>List:</label>
                            <select v-model="selectedListId" class="form-control">
                                <option :value="null">All</option>
                                <option v-for="l in lists" :value="l.Id">{{l.Name}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Status:</label>
                            <select v-model="selectedStatusId" class="form-control">
                                <option :value="null">Any</option>
                                <option v-for="s in statuses" :value="s.Id">{{s.Name}}</option>
                            </select>
                        </div>

                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button @click="handleConfirm" type="button" class="btn btn-primary">Confirm</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>      


<style scoped>
</style>